import React, { MutableRefObject } from 'react';

export function useOnScreen(ref: MutableRefObject<HTMLElement | null>) {
  const [isIntersecting, setIntersecting] = React.useState(false);

  const observer = new IntersectionObserver(
    ([entry]) => setIntersecting(entry.isIntersecting)
  );

  React.useEffect(() => {
    if (ref?.current) {
      observer.observe(ref.current);
      return () => { observer.disconnect(); };
    }
  }, [ref, observer]);

  return isIntersecting;
}

export function useScreenSize() {
  const [size, setSize] = React.useState([window.innerWidth, window.innerHeight]);

  React.useLayoutEffect(() => {
    const updateSize = () => { setSize([window.innerWidth, window.innerHeight]); };
    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return size;
}
